import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressButtonComponent } from './progress-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [ProgressButtonComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  exports: [ProgressButtonComponent, MatButtonModule, MatProgressSpinnerModule],
})
export class ProgressButtonModule {}
